import StatusTag from "../../components/StatusTag";

// Client dispatch statuses: draft | shipped | cancelled.
export function statusColor(status) {
  switch(status) {
    case "draft": return StatusTag.COLORS.GREY;
    case "shipped": return StatusTag.COLORS.GREEN;
    case "cancelled": return StatusTag.COLORS.RED;
    default: return StatusTag.COLORS.OUTLINE;
  }
}

// What the dispatch is waiting for, beyond its status: Stord to ship it, or
// serial numbers that did not ship with it. "" when nothing.
export function waitingFor(dispatch) {
  if (!dispatch) return "";
  const get = (key) => (dispatch.get ? dispatch.get(key) : dispatch[key]);
  if (get("status") === "draft" && get("stordOrderNumber")) return `Waiting for Stord to ship order ${get("stordOrderNumber")}`;
  if (get("status") === "shipped" && get("serialsPending") > 0) return `${get("serialsPending")} serial numbers missing`;
  return "";
}

export function statusLabel(status) {
  switch(status) {
    case "draft": return "Draft";
    case "shipped": return "Shipped";
    case "cancelled": return "Cancelled";
    default: return status;
  }
}
